<template>
  <div>
    <header>
      <h5 class="msg-reg-js">
        Fill out the fields below to register to Talent Pool
      </h5>
    </header>

    <el-form @submit.native.prevent class="register-form">
      <el-row style="margin-bottom:0">
        <el-col>
          <el-form-item
            :error="retrieveFieldError(modelState, 'Email')"
            :required="true"
          >
            <el-input
              placeholder="Email"
              v-model="register.email"
              style="margin-top:-10px"
            ></el-input>
          </el-form-item>

          <el-form-item
            :error="retrieveFieldError(modelState, 'FirstName')"
            :required="true"
          >
            <el-input
              placeholder="First Name"
              v-model="register.firstname"
              style="margin-top:-10px"
            ></el-input>
          </el-form-item>

          <el-form-item
            :error="retrieveFieldError(modelState, 'Surname')"
            :required="true"
          >
            <el-input
              placeholder="Last Name"
              v-model="register.surname"
              style="margin-top:-10px"
            ></el-input>
          </el-form-item>

          <el-form-item
            :error="retrieveFieldError(modelState, 'Password')"
            :required="true"
          >
            <el-input
              placeholder="Choose a password"
              type="password"
              v-model="register.password"
              show-password
              style="margin-top:-10px"
            ></el-input>
          </el-form-item>

          <el-form-item
            style="margin-bottom:20px"
            :error="
              retrieveFieldError(modelState, 'ConfirmPassword') ||
                retrieveFieldError(modelState, 'password.ConfirmPassword')
            "
            :required="true"
          >
            <el-input
              placeholder="Confirm password"
              type="password"
              v-model="register.confirmPassword"
              show-password
              style="margin-top:-10px"
            ></el-input>
          </el-form-item>

          <el-alert
            title="Password needs to have Capital Letter, Number, and Special Character."
            type="info"
            show-icon
            :closable="false"
          >
          </el-alert>

          <PasswordChecklist
            v-if="passwordCriteriaResult.length > 0"
            :Data="passwordCriteriaResult"
          ></PasswordChecklist>
        </el-col>
      </el-row>
      <el-row style="margin-top: 25px">
        <el-col>
          <el-alert
            v-if="retrieveFieldError(modelState, 'Contact')"
            :title="retrieveFieldError(modelState, 'Contact')"
            type="error"
            show-icon
          ></el-alert>
          <button
            class="ts-btn ts-btn-rounded ts-btn-secondary ts-btn-full"
            @click="signup()"
          >
            Register
          </button>
          <div style="margin-top: 10px; text-align: center">
            <p class="secondary-p">
              Already registered? <a href="/apprentice-login">Login here</a>
            </p>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      title="Cookies"
      :visible.sync="cookieDialog"
      :close-on-click-modal="false"
      :show-close="false"
      width="420px"
      center
    >
      <div style="text-align: center">
        <i class="fa fa-cookie-bite" style="font-size: 100px"></i> <br />

        &nbsp; &nbsp;

        <p id="consent-message">
          This website stores cookies on your computer. These cookies are used
          to improve your website experience and provide more personalized
          services to you, both on this website and through other media. To find
          out more about the cookies we use, see our
          <a @click="viewPrivacyPolicy()" style="cursor: pointer"
            >privacy policy.</a
          >
        </p>

        <br />

        <span
          slot="footer"
          class="dialog-footer ts-app-shell--header_actions flexed"
        >
          <el-button
            style="width: 170px"
            class="ts-btn ts-btn-small ts-btn-primary"
            @click="acceptAllCookies"
            >Accept all cookies</el-button
          >
          <el-button
            style="width: 170px"
            class="ts-btn ts-btn-small ts-btn-secondary"
            @click="acceptNecessaryCookies"
            >Necessary cookies only</el-button
          >
        </span>

        <br>

        <span
          slot="footer"
          style="margin-top:-10px;"
          class="dialog-footer ts-app-shell--header_actions flexed"
        >
          <el-button
            style="width: 350px"
            class="ts-btn ts-btn-small ts-btn-grey"
            @click="customizeCookie"
            >Customize cookies</el-button
          >          
        </span>
      </div>
    </el-dialog>

    <el-dialog
      title="Customize Cookies"
      :visible.sync="customCookieDialog"
      :close-on-click-modal="false"
      :show-close="false"
      width="620px"
      center
    >
      <div style="text-align: left">
        <h6>Privacy Preference Center</h6>

        &nbsp; &nbsp;

        <p id="consent-message">
          This website stores cookies on your computer. These cookies are used
          to improve your website experience and provide more personalized
          services to you, both on this website and through other media. To find
          out more about the cookies we use, see our
          <a @click="viewPrivacyPolicy()" style="cursor: pointer"
            >privacy policy.</a
          >
        </p>

        <el-button
          style="width: 170px"
          class="ts-btn ts-btn-small ts-btn-primary"
          @click="acceptAllCookies"
          >Accept all cookies</el-button
        >
        &nbsp;

        <h6>Manage Consent Preferences</h6>

        &nbsp; &nbsp;

        <el-collapse v-model="activeNames" style="word-break: normal;">
          <el-collapse-item name="1">
            <template slot="title">
              <el-col>
                <el-col :xl="19" :lg="19" :md="19" :sm="18" :xs="17">
                  <span style="font-weight: bold; font-size: 14px">
                    Strictly Necessary Cookies
                  </span>
                </el-col>
                <el-col :xl="5" :lg="5" :md="5" :sm="6" :xs="7">
                  <span style="color: #5ac18e; font-size: 14px; font-weight: bold">
                    Required
                  </span>
                </el-col>
              </el-col>
            </template>
            <div> 
              These cookies are essential for the website to operate and cannot be disabled in our systems. 
              They are typically only activated in response to actions you take, such as setting privacy preferences, 
              logging in, or completing forms. While you can configure your browser to block or notify you about these 
              cookies, certain site features may become unavailable. However, these cookies do not retain any personally 
              identifiable information.
            </div>
          </el-collapse-item>

          <el-collapse-item name="2">
            <template slot="title">
              <el-col>
                <el-col :xl="19" :lg="19" :md="19" :sm="18" :xs="17">
                  <span style="font-weight: bold; font-size: 14px">
                    Performance Cookies
                  </span>
                </el-col>
              </el-col>
            </template>
            <div> 
              These cookies enable us to track visits and traffic sources to measure and enhance our site's performance. 
              They provide insights into popular and less popular pages and visitor navigation patterns. All data collected 
              by these cookies is aggregated and anonymous. Without your consent for these cookies, we won't be able to 
              track your visits or monitor our site's performance effectively.
            </div>
            <br>
            <el-switch
              v-model="cookiePreference.performanceCookies"
              active-color="#00c8dc"
              inactive-color="#535353"
              active-text="Accept">
            </el-switch>
          </el-collapse-item>

          <el-collapse-item name="3">
            <template slot="title">
              <el-col>
                <el-col :xl="19" :lg="19" :md="19" :sm="18" :xs="17">
                  <span style="font-weight: bold; font-size: 14px">
                    Functional Cookies
                  </span>
                </el-col>
              </el-col>
            </template>
            <div> 
              These cookies allow the website to offer improved features and customization. 
              They can be set by us or third-party providers whose services we've incorporated 
              into our pages. If you decline these cookies, some or all of these services may 
              not work correctly.
            </div>
            <br>
            <el-switch
              v-model="cookiePreference.functionalCookies"
              active-color="#00c8dc"
              inactive-color="#535353"
              active-text="Accept">
            </el-switch>
          </el-collapse-item>

          <el-collapse-item name="4">
            <template slot="title">
              <el-col>
                <el-col :xl="19" :lg="19" :md="19" :sm="18" :xs="17">
                  <span style="font-weight: bold; font-size: 14px">
                    Targeting Cookies
                  </span>
                </el-col>
              </el-col>
            </template>
            <div> 
              These cookies enhance the relevance of advertising messages by tailoring 
              them to your interests. They can be set by us or our advertising partners 
              and help create a profile of your interests to display relevant ads on our 
              site or others. While they don't store personal information directly, they 
              identify your browser and internet device uniquely.
            </div>
            <br>
            <el-switch
              v-model="cookiePreference.targetCookies"
              active-color="#00c8dc"
              inactive-color="#535353"
              active-text="Accept">
            </el-switch>
          </el-collapse-item>
        </el-collapse>

        &nbsp; &nbsp;

        <span
          slot="footer"
          class="dialog-footer ts-app-shell--header_actions flexed"
        >
          <el-button
            style="width: 170px"
            class="ts-btn ts-btn-small ts-btn-primary"
            @click="acceptNecessaryCookies"
            >Necessary cookies only</el-button
          >
          <el-button
            style="width: 170px"
            class="ts-btn ts-btn-small ts-btn-secondary"
            @click="acceptMyCookies"
            >Confirm my choices</el-button
          >
        </span>
      </div>
    </el-dialog>

    <PrivacyPolicy
      :showPrivacyPolicy="showPrivacyPolicy"
      @close-privacy-modal="hidePrivacyPolicy"
    >
    </PrivacyPolicy>
    
    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import PasswordChecklist from "../../jobseeker/components/PasswordChecklist";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import TSLoading from "@/components/TSLoading.vue";

export default {
  components: {
    PasswordChecklist,
    PrivacyPolicy,
    TSLoading
  },
  created() {
    let params = new URLSearchParams(window.location.search);
    this.contactid = params.get("cid");

    //  this.$store.dispatch('jobseeker/isLogged')
    //   .then((res) => {
    //       if(res.data == true) {
    //         if(this.userHasRole(process.env.VUE_APP_ROLE_SEEKER)) {
    //           this.$router.push({ name: 'jobseeker-dashboard' });
    //         }
    //       }
    //   });
  },
  data() {
    return {
      register: {},
      login: {},
      isLoading: false,
      hasError: false,
      modelState: {},
      details: {},
      invite: [],
      contactid: null,
      passwordCriteriaResult: [],
      cookieDialog: false,
      customCookieDialog: false,
      showPrivacyPolicy: false,
      activeNames: ['0'],
      cookiePreference: {
        requiredCookies: true,
        performanceCookies: false,
        functionalCookies: false,
        targetCookies: false
      } 
    };
  },
  methods: {
    signup() {
      this.modelState = {};
      this.passwordCriteriaResult = [];
      this.isLoading = true;
      if (this.contactid != null) this.register.ContactId = this.contactid;
      this.register.source = 2;
      this.$store
        .dispatch("account/register", this.register)
        .then(res => {
          this.$message.success("Registration Success!");
          this.isLoading = false;
          this.$confirm(
            `<p> You're signed up. <br/> TalentSensus is here to help you make your dream job come true. <br/><br/> </p>`,
            "Well Done!!!",
            {
              confirmButtonText: "Continue Login",
              confirmButtonClass:
                "ts-btn ts-btn-rounded ts-btn-secondary lgn-btn",
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              type: "success",
              center: true
            }
          ).then(() => {
            this.isLoading = true;
            this.login.source = 2;
            this.login.email = this.register.email;
            this.login.password = this.register.confirmPassword;
            this.$store.dispatch("account/login", this.login).then(res => {
              this.validateCookie();
              this.isLoading = false;
            });
          })
          .catch(res => {
            this.modelState = res.errors;
            this.isLoading = false;
          });
        })
        .catch(res => {
          this.passwordCriteriaResult = [];
          if (res.errors !== undefined) {
            let password = res.errors['Password'];
            if (password) {
              if (password.find((c) => c.indexOf(",") != -1)) {
                this.passwordCriteriaResult = password;
                res.errors['Password'] = [];
              }
            }
          }
          
          if (res.errors !== undefined) {
            this.modelState = res.errors;
          } else {
            this.modelState = res;
          }
          this.isLoading = false;
        });
    },
    validateCookie() {
      var cookie = this.getCookie(
        `ts-cookie-${this.$store.state.account.current_user.id}`
      );
      if (!cookie) {
        this.cookieDialog = true;
      } else {
        this.$message.success("Login Successful!");
        this.$router.push({ name: "apprentice-dashboard" });
      }
    },
    getCookie(key) {
      const cookie = `${key}=`;
      const doc = decodeURIComponent(document.cookie);
      const arrCookies = doc.split("; ");
      let value;
      arrCookies.forEach((val) => {
        if (val.indexOf(cookie) === 0) value = val.substring(cookie.length);
      });

      if (value == undefined) return false;
      else return value;
    },acceptAllCookies() {      
      this.cookiePreference.requiredCookies = true;
      this.cookiePreference.performanceCookies = true;
      this.cookiePreference.functionalCookies = true;
      this.cookiePreference.targetCookies = true;

      const tsCookie = JSON.stringify(this.cookiePreference);
      document.cookie = `ts-cookie-${this.$store.state.account.current_user.id}=${tsCookie};expires=Fri, 31 Dec 9999 23:59:59 GMT`;
      
      this.cookieDialog = false;
      this.customCookieDialog = false;

      this.$message.success("Login Successful!");
      this.$router.push({ name: "apprentice-dashboard" });
    },
    acceptNecessaryCookies() {
      this.cookiePreference.requiredCookies = true;
      this.cookiePreference.performanceCookies = false;
      this.cookiePreference.functionalCookies = false;
      this.cookiePreference.targetCookies = false;

      const tsCookie = JSON.stringify(this.cookiePreference);
      document.cookie = `ts-cookie-${this.$store.state.account.current_user.id}=${tsCookie};expires=Fri, 31 Dec 9999 23:59:59 GMT`;  

      this.cookieDialog = false;
      this.customCookieDialog = false;

      this.$message.success("Login Successful!");
      this.$router.push({ name: "apprentice-dashboard" });
    },
    acceptMyCookies() {
      const tsCookie = JSON.stringify(this.cookiePreference);
      document.cookie = `ts-cookie-${this.$store.state.account.current_user.id}=${tsCookie};expires=Fri, 31 Dec 9999 23:59:59 GMT`; 

      this.cookieDialog = false;
      this.customCookieDialog = false;

      this.$message.success("Login Successful!");
      this.$router.push({ name: "apprentice-dashboard" });
    },
    customizeCookie() {
      this.cookieDialog = false;
      this.customCookieDialog = true;
    },
    viewPrivacyPolicy() {
      this.showPrivacyPolicy = true;
    },
    hidePrivacyPolicy() {
      this.showPrivacyPolicy = false;
    }
  }
};
</script>

<style>
.msg-reg-js {
  padding-top: 20px;
  padding-bottom: 10px;
}

.lgn-btn {
  width: 50%;
  max-width: none;
  margin: auto !important;
}
</style>
